import React, {useState} from 'react';
import { Link } from 'react-router-dom'
import { makeStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AssignmentIcon from '@material-ui/icons/Assignment';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import FavoriteIcon from '@material-ui/icons/Favorite';
import StreetviewIcon from '@material-ui/icons/Streetview';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GetAppIcon from '@material-ui/icons/GetApp';
import Close from "@material-ui/icons/Close";
import FichaLink from 'Ficha/pdf/fichaLink'
import FichaDownloadLink from 'Ficha/pdf/fichaDownloadLink'
import TcleLink from 'Ficha/pdf/tcleLink'
import {apagarFicha} from 'firebase/firestoreData'

const styles = {
  item:{
    color: 'rgb(50, 50, 50)',
    fontSize: '8pt',
  },
  green:{
    color: 'green',
  },
  black:{
    color: 'black'
  }
}

const useStyles = makeStyles(styles);

export default function RecordsMenu(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false)
  const open = Boolean(anchorEl);

  function handleDelete(id) {
    apagarFicha(id)
    handleCloseMenu()
    handleCloseDialog()
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
   setOpenDialog(true);
 };

 const handleCloseDialog = () => {
   setOpenDialog(false);
 };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleCloseMenu}
        PaperProps={{
          style: {
            width: '20ch',
          },
        }}
      >
      { anchorEl &&
        <div>
          <div>
            <FichaLink ficha={props.ficha}
                       link={<MenuItem onClick={handleCloseMenu} className={classes.item}>
                              <ListItemIcon>
                               <PictureAsPdfIcon fontSize="small" className={classes.black}/>
                              </ListItemIcon>
                              <Typography variant="inherit">
                               IMPRIMIR
                              </Typography>
                             </MenuItem>
                            }
            />
          </div>
          <div>
            <FichaDownloadLink ficha={props.ficha}
                               link={<MenuItem onClick={handleCloseMenu} className={classes.item}>
                                      <ListItemIcon>
                                        <GetAppIcon fontSize="small" />
                                      </ListItemIcon>
                                      <Typography variant="inherit">
                                       BAIXAR PDF
                                      </Typography>
                                     </MenuItem>
                                    }
            />
          </div>
          <Divider light/>
          <div>
            <TcleLink ficha={props.ficha}
                      link={<MenuItem onClick={handleCloseMenu} className={classes.item}>
                              <ListItemIcon>
                                <AssignmentIcon fontSize="small" color="primary"/>
                              </ListItemIcon>
                              <Typography variant="inherit">
                                TERMO
                              </Typography>
                            </MenuItem>
                            }
            />
          </div>
        <Link to={{pathname: '/fees', state: {...props.ficha,
                                             data: props.ficha.data.toDate(),
                                             }}}>
          <MenuItem onClick={handleCloseMenu} className={classes.item}>
            <ListItemIcon>
              <MonetizationOnIcon fontSize="small" className={classes.green}/>
            </ListItemIcon>
            <Typography variant="inherit">ORÇAMENTO</Typography>
          </MenuItem>
        </Link>
        <Divider light/>
        <Link to={{pathname: '/lee', state: {...props.ficha,
                                             data: props.ficha.data.toDate(),
                                             }}}>
          <MenuItem onClick={handleCloseMenu} className={classes.item}>
            <ListItemIcon>
              <FavoriteIcon fontSize="small" color="secondary"/>
            </ListItemIcon>
            <Typography variant="inherit">LEE</Typography>
          </MenuItem>
        </Link>
        <Link to={{pathname: '/emapo', state: {...props.ficha,
                                             data: props.ficha.data.toDate(),
                                             }}}>
          <MenuItem onClick={handleCloseMenu} className={classes.item}>
            <ListItemIcon>
              <FavoriteIcon fontSize="small" color="secondary"/>
            </ListItemIcon>
            <Typography variant="inherit">EMAPO</Typography>
          </MenuItem>
        </Link>
        <Link to={{pathname: '/apfel', state: {...props.ficha,
                                             data: props.ficha.data.toDate(),
                                             }}}>
          <MenuItem onClick={handleCloseMenu} className={classes.item}>
            <ListItemIcon>
              <StreetviewIcon fontSize="small" className={classes.green}/>
            </ListItemIcon>
            <Typography variant="inherit">APFEL (NVPO)</Typography>
          </MenuItem>
        </Link>


      </div>
      }
        <Divider/>
        <MenuItem  className={classes.item} onClick={()=>{handleOpenDialog()}}>
          <ListItemIcon>
            <Close fontSize="small" color="error"/>
          </ListItemIcon>
          <Typography variant="inherit">APAGAR</Typography>
        </MenuItem>
      </Menu>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"APAGAR FICHA"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Você tem certeza que deseja apagar a ficha de A.P.A.?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={()=>{handleDelete(props.ficha.id)}} color="primary" autoFocus>
            Apagar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
 );
}
